import { useFocusRing } from '@react-native-aria/focus'
import clsx from 'clsx'
import type { ReactNode } from 'react'
import { ActivityIndicator, Pressable, View, type PressableProps } from 'react-native'

import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import { ICON } from '@/src/general/enums/icons'
import { dataFocusVisibleClasses } from '@/src/styles/classes'
import { colors } from '@/src/styles/colors'

export type TSettingsProfileButtonProps = Pick<PressableProps, 'onPress'> & {
  className?: string
  isLoading?: boolean
  label: string
  placeholder?: string
  value?: string
  testID?: string
}

export const SettingsProfileButton = ({
  className,
  isLoading,
  label,
  onPress,
  placeholder,
  value,
  testID,
}: TSettingsProfileButtonProps): ReactNode => {
  const { isFocusVisible, focusProps } = useFocusRing()

  const hasValue = typeof value !== 'undefined'

  return (
    <Pressable
      className={clsx(
        'cursor-pointer flex-row justify-between gap-3 rounded-lg px-4 py-3 hover:bg-white',
        dataFocusVisibleClasses,
        className,
      )}
      onPress={onPress}
      dataSet={{ 'focus-visible': isFocusVisible }}
      {...focusProps}
      testID={testID}
    >
      <View className="flex-1 gap-1">
        <Typography size="xs">{label}</Typography>
        <Typography bold={hasValue} className={!hasValue ? 'text-default-text-placeholder' : undefined}>
          {value || (isLoading ? '...' : placeholder)}
        </Typography>
      </View>
      {isLoading ? (
        <ActivityIndicator color={colors.primary['icon-contrast-lower'].DEFAULT} />
      ) : (
        <Icon size="md" className="pointer-events-none text-primary-icon-contrast-lower" name={ICON.PENCIL} />
      )}
    </Pressable>
  )
}
